/** @jsx jsx */
import { jsx } from 'theme-ui';
import { rgba } from 'polished';
import Link from '../link';
import UnbulletedList from '../styles/unbulleted-list';
import { colors } from '../../gatsby-plugin-theme-ui';

export const NavContainer = (props) => (
  <nav
    sx={{
      bg: rgba(colors.SecondaryGray3, 0.75),
      display: 'flex',
      flexWrap: ['wrap', null, 'nowrap'],
      fontSize: '1.4rem',
      lineHeight: 1.29,
      py: '4rem',
      px: [null, null, '5.1rem'],
    }}
    {...props}
  />
);

export const NavBuckets = (props) => (
  <div
    sx={{
      display: 'flex',
      flexWrap: ['wrap', null, 'nowrap'],
      flexBasis: [null, '100%'],
    }}
    {...props}
  />
);

export const Bucket = (props) => (
  <UnbulletedList
    sx={{
      flexBasis: ['50%', '25%', '16.7%'],
      px: ['1.4rem', '2.8rem', '1.4rem'],
      py: '2rem',
    }}
    {...props}
  />
);

export const SinglePageBucket = (props) => (
  <UnbulletedList
    sx={{
      py: '2rem',
      display: ['flex', 'block'],
      flexWrap: 'wrap',
      width: '100%',
      flexBasis: [null, '25%', '14%'],
    }}
    {...props}
  />
);

export const SinglePageContainer = (props) => (
  <li
    sx={{
      flexBasis: '50%',
      px: ['1.4rem', '2.8rem', '1.4rem'],
      pr: [null, null, 0],
    }}
    {...props}
  />
);

export const NavLink = (props) => (
  <Link
    sx={{
      display: 'inline-block',
      py: '1rem',
      color: 'PrimaryDarkBlue',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    }}
    {...props}
  />
);

export const SectionLink = (props) => (
  <NavLink
    sx={{
      fontWeight: 'bold',
      pt: '2rem',
      pb: '1rem',
    }}
    {...props}
  />
);

// export const SinglePageLink = (props) => (
//   <NavLink
//     sx={{
//       fontWeight: 'bold',
//       py: '2rem',
//       flexBasis: '50%',
//     }}
//     {...props}
//   />
// );
